/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React, { Fragment, useState, useEffect, useCallback } from 'react';
import ItemShimmer from '../../../../components/Shimmer/itemShimmer';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId';
import { dataService } from '../../../../services/data.services';
import Pagination from "../../../../components/Pagination";
import moment from 'moment';

export default function StudentList({
    selectedAcademicYear,
    selectedClass,
    selectedSection,
    selectedFeeTermData,
    selectedStudents,
    setSelectedStudents,
}) {
    const [searchParams, setSearchParams] = useSearchParams({ student_page_number: 1 });
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate();
    const itemsPerPage = 20;
    const [suggestions, setSuggestions] = useState("");
    const [isClearVisible, setIsClearVisible] = useState(searchParams.get('search') || "" !== "");
    const [studentListLoading, setStudentListLoading] = useState(false);
    const [studentTotalCount, setStudentTotalCount] = useState(0);
    const [is_all_fee_structure, setIs_all_fee_structure] = useState(true);
    const [allStudents, setAllStudents] = useState([]);
    const [studentsList, setStudentsList] = useState([]);
    
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [selectAll, setSelectAll] = useState(false);

    const getStudentsList = useCallback(async () => {
        setStudentListLoading(true);
        const branch_id = await GetBranchId();
        const searchValue = searchParams.get("search");

        const query = new URLSearchParams({
            is_all_fee_structure: is_all_fee_structure.toString(),
            branch_id: branch_id.toString(),
            page_number: searchParams.get("student_page_number"),
            academic_year: selectedAcademicYear?.name || "",
            class_: selectedClass?.name || "",
            section_: selectedSection?.name || "",
            filter: "true",
            status: "active",
            limit: itemsPerPage,
            is_fee_structure: "true",
        });

        // Add `search` only if it's not empty
        if (searchValue && searchValue.trim() !== "") {
            query.append("search", searchValue);
        }

        const response = await dataService.GetAPI(`students?${query.toString()}`);

        if (response.data.status === 200) {
            const data = response.data;
            setStudentsList(data.data.students);
            if (is_all_fee_structure) {
                setAllStudents(data.data.allFeeStructureStudents);
            }
            setStudentTotalCount(data.data.total_count);
        }
        setStudentListLoading(false);
        setIs_all_fee_structure(false);
    }, [searchParams]);

    const handleChange = (e) => {
        setSuggestions(e.target.value);
        setIsClearVisible(e.target.value !== "");
    };

    const handleOnClickPageNumber = (pageNum) => {
        const params = Object.fromEntries(searchParams);
        setSearchParams({ ...params, student_page_number: pageNum.selected + 1 });
    };

    useEffect(() => {
        const pages = Math.ceil(studentTotalCount / itemsPerPage) || 1;
        if (pages !== totalPages) {
            setTotalPages(pages);
        }
    }, [studentTotalCount, itemsPerPage, totalPages]);

    const handleCheckboxChange = (student, checked) => {
        if (checked) {
            setSelectedStudents((prev) => [...prev, student]);
        } else {
            setSelectedStudents((prev) =>
                prev.filter((s) => s._id !== student._id)
            );
            setIsAllSelected(false);
        }
    };

    const handleSelectAllChange = (checked) => {
        setSelectAll(checked);
        if (checked) {
            setSelectedStudents(allStudents);
        } else {
            setSelectedStudents([]);
        }
    };


    useEffect(() => {
        const allSelected = studentsList.length > 0 && studentsList.every(student =>
            selectedStudents?.some((s) => s._id === student._id)
        );
        setIsAllSelected(allSelected);
    }, [selectedStudents, studentsList]);

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            const params = Object.fromEntries(searchParams);
            setSearchParams({
                ...params,
                student_page_number: 1,
                search: suggestions,
            });
        }
    };

    const clearAndperformSearch = () => {
        setSuggestions("");
        setIsClearVisible(false);
        const params = Object.fromEntries(searchParams);
        delete params.search;
        setSearchParams({ ...params, student_page_number: 1 });
    };

    // To get selected students list
    // const selectedStudents = studentsList.filter(
    //   (student) => selectedStudentsMap[student.student_uuid]
    // );

    useEffect(() => {
        getStudentsList();
    }, [
        searchParams.get("student_page_number"),
        searchParams.get("search"),
    ]);

    return (

        <div className="mx-auto mt-4 pb-[130px]">
            <div class="mb-6 p-3 border border-[#D0D5DD] rounded flex w-[80%] mx-auto">
                <div class="w-[40%] px-1">
                    <div class="flex mb-3">
                        <a class="min-w-[135px]">Academic Year</a>
                        <a class="font-semibold break-all">{selectedAcademicYear?.name}</a>
                    </div>

                    <div class="flex mb-3">
                        <a class="min-w-[135px]">Class</a>
                        <a class="font-semibold break-all w-[70%]">{selectedClass?.name}</a>
                    </div>
                    <div class="flex mb-3">
                        <a class="min-w-[135px]">Section</a>
                        <a class="font-semibold break-all w-[70%]">{selectedSection?.name}</a>
                    </div>
                </div>
                <div class="px-1 w-[60%]">
                    {selectedFeeTermData?.terms?.length === 0 ? (<div className="flex justify-center items-center w-full">
                        <p className="p-8 mb-8 min-h-[200px] text-center">No Terms available</p>
                    </div>
                    ) : (
                        selectedFeeTermData?.terms?.map((term, originalIndex) => {
                            const isFutureTerm = moment(term?.end_date.split("T")[0]).isSameOrAfter(moment());
                            const endDate = moment(term?.end_date?.split("T")[0]);
                            const startDate = moment(term?.start_date?.split("T")[0]);

                            return (
                                <div className="pl-2" key={originalIndex}>
                                    <div className="flex flex-col justify-between overflow-y-auto scroll-bar mb-3 rounded w-full relative">
                                        <div>
                                            <p className="">
                                                <span className='font-semibold'>{term?.term_name}:&nbsp;</span>
                                                <span>{`${startDate.format("DD MMM YYYY")} - ${endDate.format("DD MMM YYYY")}`}</span>
                                                <span className="text-f7 font-normal text-[#031624]">{` | Fee: ${parseFloat(term?.term_amount).toFixed(2) || "-"}`}</span>
                                                {!isFutureTerm && (
                                                    <span className="text-red-600 font-normal text-xs ml-2">(Not Billable)</span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
            <div className="flex justify-between items-center">
                <div className="flex justify-start"><p class="text-lg font-semibold text-[#000000]">Students List<span className='text-xs font-grey-500 font-normal'>&nbsp;(Only students without a fee structure are listed below)</span></p></div>
                <div className="flex justify-end">
                    <div className="relative search-tab">
                        <label htmlFor="input"></label>
                        <div className="absolute top-[52%] -translate-y-[50%]" id="search_button">
                            <button
                                type="button"
                                id="search-button"
                                className="inline-block"
                                data-te-toggle="modal"
                                data-te-target="#exampleModalCenter"
                                data-te-ripple-init
                                data-te-ripple-color="light"
                            >
                                <img
                                    loading="lazy"
                                    decoding="async"
                                    src="/images/search.svg"
                                    alt="img"
                                />
                            </button>
                        </div>
                        <div className="relative flex">
                            <input
                                maxLength={90}
                                type="text"
                                id="search-value"
                                autoComplete="off"
                                value={suggestions || searchParams.get('search') || ""}
                                autoFocus={suggestions !== ""}
                                onChange={handleChange}
                                onKeyPress={handleKeyPress}
                                placeholder="Student Name / ID"
                                style={{ 'width': '165px' }}
                            />
                        </div>
                        {isClearVisible && (
                            <div
                                className="absolute cross_icon"
                                id="clear_icon"
                                onClick={clearAndperformSearch}
                                title="Clear Search"
                            />
                        )}
                    </div>
                </div>
            </div>

            <div className='w-full mt-1'>
                <div className='mb-2 '>
                    {studentListLoading ? (
                        <ItemShimmer />
                    ) : (
                        <>
                            <table className="w-full table-auto greyHeader" id="admin-table">
                                <thead className='top-0 left-0 bg-white'>
                                    <tr className='student-th'>
                                        <th className="w-[5%]">
                                            <div className="relative checkbox custom-checkBoxBlueBranch1">
                                                <input
                                                    type="checkbox"
                                                    id="select-all"
                                                    checked={selectAll}
                                                    onChange={(e) => handleSelectAllChange(e.target.checked)}
                                                    className="accent-green-600 w-4 h-4"
                                                />
                                                <label htmlFor="select-all" className="ml-2">

                                                </label>
                                            </div>
                                        </th>
                                        <th className="w-[30%]"><span className="flex items-center justify-start font-semibold pl-2">Student ID</span></th>
                                        <th className="w-[50%]"><span className="flex items-center justify-start font-semibold pl-2">Student Name</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(studentsList) && studentsList.map((student) => {
                                        const isChecked = selectedStudents?.some(s => s._id === student._id);
                                        return (
                                            <Fragment key={student._id}>
                                                <tr>
                                                    <td>
                                                        <div className="relative checkbox custom-checkBoxBlueBranch1">
                                                            <input
                                                                type="checkbox"
                                                                id={`student-checkbox-${student._id}`}
                                                                checked={isChecked}
                                                                onChange={(e) => handleCheckboxChange(student, e.target.checked)}
                                                            />
                                                            <div className="absolute left-6 bottom-7 bg-gray-300 text-gray-800 text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity shadow-md whitespace-nowrap">
                                                                Select Student
                                                            </div>
                                                            <label
                                                                htmlFor={`student-checkbox-${student._id}`}
                                                                className="text-f7 font-normal text-[#031624] pl-2.5 w-full cursor-pointer"
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='flex items-center'>
                                                            <p className='justify-start flex'>{student.student_id}</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='flex items-center'>
                                                            <p className='justify-start flex'>{student.full_name}</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </>
                    )}
                </div>

                {studentTotalCount > itemsPerPage && (
                    <Pagination
                        TotalCount={studentTotalCount}
                        totalPageNumber={totalPages}
                        selectedPageNumber={Number(searchParams.get('student_page_number')) || 1}
                        handleOnClickPageNumber={handleOnClickPageNumber}
                        limit={itemsPerPage}
                    />
                )}
            </div>
        </div>
    );
}




